import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

interface Props {
  className?: string;
}

export const NothingToSeeHere: FC<Props> = (props) => {
  const msg = useLocale();

  return <div className={props.className}>{msg.nothingToSeeHere.title}</div>;
};
